import React from "react";
import LayoutBasic from "../../layouts/LayoutBasic";
import SettingSubpage from "../../modules/SettingSubpage";

const Settingpage = () => {
  return (
    <div >
    <LayoutBasic>
      <SettingSubpage ></SettingSubpage>
    </LayoutBasic>
    </div>
  );
};

export default Settingpage;
